module.exports = __webpack_public_path__ + "static/media/1009862.5c6dbdcb.jpg";